import { render } from "./index.vue?vue&type=template&id=52ccb200&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=52ccb200&scoped=true&lang=css"

import exportComponent from "/opt/server_deploy/hnyj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ccb200"]])

export default __exports__